<template>
    <div>
        <!--
        <div class="group-label">
            {{ $t('unit.group.posInGroup') }}
        </div>
        -->

        <div class="w-100 text-center" style="height: 18px; font-size: 15px;">
            {{ position }}
        </div>

        <div class="w-100 v-flex mt-2" style="justify-content: center">
            <div
                class  ="secondary lighten-4 group-room"
                :style = "height"
            >
                <div style="width: 60px; position: absolute; top: 40px; left: 8px" v-if="typeOfGroup">
                    <v-card
                        v-for  = "index in posmap[typeOfGroup-1]"
                        :key   = "index"
                        class  = "group-entry mb-1"
                        :class = "(index < posmap[typeOfGroup-1] ? 'mr-2 ' : '') + (index === selected.left ? 'primary' : '')"
                        @click = "onClickLeft(index)"
                        flat
                    >
                        <v-icon
                            size="28"
                            class="text-grey-lighten-"
                            style="margin-top: -3px"
                            :color="index === selected.left ? 'white' : 'secondary lighten-4'"
                        >
                            mdi-elevator-passenger
                        </v-icon>
                    </v-card>
                </div>

                <div class="text-primary group-room-entry">
                    Eingang
                </div>

                <div style="padding-top: 8px; padding-left: 40px; position: absolute; top: 0" v-if="typeOfGroup">
                    <div class="v-flex">
                        <v-card
                            v-for   = "index in posmap[typeOfGroup-1]"
                            :key    = "index"
                            class   = "group-entry "
                            :class  = "(index < posmap[typeOfGroup-1] ? 'mr-1 ' : '') + (index === selected.bottom ? 'primary' : '')"
                            @click  = "onClickBottom(index)"
                            flat
                        >
                            <v-icon
                                size   = "28"
                                class  = ""
                                style  = "margin-top: -3px"
                                :color = "index === selected.bottom ? 'white' : 'secondary lighten-4'"
                            >
                                mdi-elevator-passenger
                            </v-icon>
                        </v-card>
                    </div>

                </div>

                <div style="width: 32px; position: absolute; top: 40px; right: 8px" v-if="typeOfGroup">
                    <v-card
                        v-for   = "index in posmap[typeOfGroup-1]"
                        :key    = "index"
                        class   = "group-entry mb-1"
                        :class  = "(index < posmap[typeOfGroup-1] ? 'mr-2 ' : '') + (index === selected.right ? 'primary' : '')"
                        @click  = "onClickRight(index)"
                        flat
                    >
                        <v-icon
                            size="28"
                            class="text-grey-lighten-"
                            style="margin-top: -3px"
                            :color="index === selected.right ? 'white' : 'secondary lighten-4'"
                        >
                            mdi-elevator-passenger
                        </v-icon>
                    </v-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PElevatorGroupPosition",

    props: {
        typeOfGroup: {

        },

        value: {

        },

        readonly: {

        }
    },

    data: () => ({
        selected: {
            left: null,
            right: null,
            bottom: null
        },

        position: null,

        posmap: [
            2,
            3,
            4,
            5,
            6,
            8
        ]
    }),

    computed: {
        height () {
            let height = null;
            let width = null;

            switch (this.typeOfGroup) {
                case 1:
                    height = 88;
                    width = 128;
                    break;
                case 2:
                    height = 126;
                    width = 170;
                    break;
                case 3:
                    height = 144;
                    width = 174;
                    break;
                case 4:
                    height = 202;
                    width = 214;
                    break;
                case 5:
                    height = 210;
                    width = 250;
                    break;
                case 6:
                    height = 276;
                    width = 320;
                    break;
            }

            return "height: " + (height + 60) + "px; width: " + (width + 49) + 'px';
        },


    },

    mounted() {
        this.setSelected();
    },

    watch: {
        value () {
            this.setSelected();
        },

        typeOfGroup () {
            this.$emit("input", null)
        }
    },

    methods: {
        onClickLeft (index) {
            if (this.readonly) {
                return;
            }

            this.selected.right = null;
            this.selected.bottom = null;
            this.$emit("update:modelValue", index);
            this.position = "Links " + (1 + this.posmap[this.typeOfGroup-1] - index) + ". Aufzug";

        },

        onClickRight (index) {
            if (this.readonly) {
                return;
            }

            this.selected.left = null;
            this.selected.bottom = null;
            this.$emit("update:modelValue", index+10)
            this.position = "Rechts " + (1 + this.posmap[this.typeOfGroup-1] - index) + ". Aufzug";
        },

        onClickBottom (index) {
            if (this.readonly) {
                return;
            }

            this.selected.left = null;
            this.selected.right = null;
            this.$emit("update:modelValue", index+20)
            this.position = "Mitte " + index + ". Aufzug";
        },

        setSelected () {
            if (!this.value)   {
                this.selected.left = null;
                this.selected.right = null;
                this.selected.bottom = null;
                this.position = null;
                return;
            }

            if (this.value < 10) {
                this.selected.left = this.value;
                this.selected.right = null;
                this.selected.bottom = null;
                this.position = "Links " + (1 + this.posmap[this.typeOfGroup-1] - this.selected.left) + ". Aufzug";
                return;
            }

            if (this.value < 20) {
                this.selected.left = null;
                this.selected.right = this.value - 10;
                this.selected.bottom = null;
                this.position = "Rechts " + (1 + this.posmap[this.typeOfGroup-1] - this.selected.right) + ". Aufzug";
                return;
            }

            if (this.value < 30) {
                this.selected.left = null;
                this.selected.right = null;
                this.selected.bottom = this.value - 20;
                this.position = "Mitte " + this.selected.bottom + ". Aufzug";
            }
        },
    }
}
</script>

<style scoped>

.group-label {
    font-size: 12px;
    color: rgba(0,0,0,.6);
}

.group-entry {
    width: 32px;
    height: 30px;
    padding-left: 1px;
    padding-top: 2px;
    border-style: solid;
    border-width: 1px;
    border-color: lightgray;
}

.group-room {
    position: relative;
    border-style: solid;
    border-width: 2px;
    border-radius: 12px;
}

.group-room-entry {
    font-size: 16px;
    font-weight: 400;
    background-color: white;
    width: 100px;
    text-align: center;
    position: absolute;
    bottom: 10px;
    left: calc(50% - 50px);
    height: 32px;
    margin-bottom: -26px;
    padding-top: 2px;
    border-width: 2px;
    border-style: solid;
    border-color: rgb(146, 164, 180);
    border-radius: 6px;
}

</style>
